import type {TabPanelProps} from '../interface/TabPanelProps';
import {Box} from '@mui/material';
import React from 'react';

export default function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, tabPanelPrefix, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${tabPanelPrefix}panel-${index}`}
      aria-labelledby={`${tabPanelPrefix}-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3, pb: 3 }}>{children}</Box>}
    </div>
  );
}
